// extracted by mini-css-extract-plugin
export default {"textareaContainer":"textarea_textareaContainer__vRjMh","textareaWrapper":"textarea_textareaWrapper__narXk","textarea":"textarea_textarea__z8u-2"};